import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { ContactButton } from 'src/components/selfService/features/Signup/pages/SignupInfoPage/ContactButton/ContactButton';

export const ContactOptions: React.FC = () => {
  return (
    <ContactButton
      text={
        <Copy
          className="ellipsisOverflow"
          variant="body"
          textAlign="center"
          color="globals.white"
          display="block"
          title="Get Started With Grubhub Corporate"
        >
          Get Started With Grubhub Corporate
        </Copy>
      }
      href="https://corporate.grubhub.com/contact-us/"
      variant="primary"
    />
  );
};
